var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gotop"}},[_c('a',{attrs:{"href":"javascript:void(0)","title":"回頂端"}},[_c('img',{attrs:{"src":"/images/GoTop.svg","alt":"回頂端"}})])])
}]

export { render, staticRenderFns }